document.addEventListener('DOMContentLoaded', () => {
  // --- TAB SWITCHING ---
  const tabs = document.querySelectorAll('.custom-filter-tab');
  const panels = document.querySelectorAll('.custom-filter-panel');
  const filterContainer = document.querySelector('.main-products-grid__filters');
  const filterToggleBtn = document.querySelector('.products-toolbar__filter-btn');

  function activateTab(index) {
    tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
    panels.forEach(p => (p.style.display = 'none'));

    const tab = tabs[index];
    const panel = panels[index];
    if (tab && panel) {
      tab.setAttribute('aria-selected', 'true');
      panel.style.display = 'block';
    }
  }

  // Activate first tab by default
  activateTab(1);

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => activateTab(i));
  });

  // --- SHOW MORE BUTTON ---
  const filterLists = document.querySelectorAll('.custom-filter-list');
  filterLists.forEach(list => {
    const items = list.querySelectorAll('li');
    if (items.length > 7) {
      items.forEach((item, i) => { if (i >= 7) item.style.display = 'none'; });

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-show-more-btn';
      btn.textContent = '+ More';
      list.after(btn);

      btn.addEventListener('click', () => {
         filterToggleBtn.click();
      });
    }
  });

 // Select all custom checkboxes
  const customCheckboxes = document.querySelectorAll('.custom-checkbox');

  customCheckboxes.forEach((input) => {
    input.addEventListener('change', (e) => {
      const isChecked = e.target.checked;
      const customName = e.target.getAttribute('name');
      const customValue = e.target.value;

      console.log('Custom checkbox clicked:', customName, customValue, 'Checked:', isChecked);


      const defaultFilters = document.querySelectorAll('.disclosure__content input[type="checkbox"]');

      defaultFilters.forEach((defaultInput) => {
        const defaultName = defaultInput.getAttribute('name');
        const defaultValue = defaultInput.value;


        if (customName === defaultName && customValue === defaultValue) {
          const defaultLabel = defaultInput.nextElementSibling;

          if (defaultLabel && defaultInput.checked !== isChecked) {
            defaultLabel.click(); 
          }
        }
      });

      const li = e.target.closest('li');
      if (li) {
        if (isChecked) li.classList.add('selected');
        else li.classList.remove('selected');
      }
    });
  });
});